export default "__VITE_ASSET__CGedi26G__"